import { DAYS, HOURS, MINUTES, SECONDS, WEEKS } from "./../time.ts";
import type { DurationOption, DurationSettings } from "./types.ts";

export const DEFAULT_EXPIRY_DURATION_OPTIONS: Readonly<DurationOption[]> = [
  { time: 5, unit: "m", value: "5 minutes" },
  { time: 1, unit: "h", value: "1 hour" },
  { time: 24, unit: "h", value: "1 day" },
  { time: 168, unit: "h", value: "1 week" },
  { time: 720, unit: "h", value: "30 days" },
];

export const DEFAULT_MAX_ACCESS_DURATION: DurationOption = {
  time: 180,
  unit: "d",
  value: "180 days",
};

export const DEFAULT_STANDING_ACCESS_DURATION: DurationOption = {
  time: 24,
  unit: "h",
  value: "24 hours",
};

export const DEFAULT_APPROVABLE_DURATION: DurationOption = {
  time: 14,
  unit: "d",
  value: "14 days",
};

export const DEFAULT_DURATION_SETTINGS: Required<DurationSettings> = {
  options: DEFAULT_EXPIRY_DURATION_OPTIONS,
  approvableDuration: DEFAULT_APPROVABLE_DURATION,
  maxAccessDuration: DEFAULT_MAX_ACCESS_DURATION,
  standingAccessDuration: DEFAULT_STANDING_ACCESS_DURATION,
} as const;

export const DURATION_OPTIONS_SECONDS = {
  s: 1,
  m: MINUTES / SECONDS,
  h: HOURS / SECONDS,
  d: DAYS / SECONDS,
  w: WEEKS / SECONDS,
} as const;

export const DURATION_SETTINGS_COLLECTION = "workflow-configuration";
export const durationSettingsPath = (tenantId: string) =>
  `o/${tenantId}/${DURATION_SETTINGS_COLLECTION}/latest`;

export const AUDIT_LOG_COLLECTION = "audit-events";

export enum SSO_OIDC_PROVIDERS {
  "azure" = "azure-oidc",
  "google" = "google-oidc",
}

export const MAX_REQUEST_WAIT_TIMEOUT = 5 * MINUTES;
export const STREAMING_HEARTBEAT_INTERVAL = 2 * SECONDS;
